import { api } from "./api/client";
import type { PipelineCandidate, PipelineStage } from "@/types";

export const crmService = {
  pipeline: async () => (await api.get<PipelineStage[]>("/crm/pipeline")).data,
  candidates: async (q = "") =>
    (await api.get<PipelineCandidate[]>("/crm/candidates", { params: { q } })).data,
};
